import theme from '@/constants/theme';
import React from 'react';

export const styles: Record<string, React.CSSProperties> = {
  container: {
    backgroundColor: 'inherit',
    flex: 1,
  },
  progressContainer: {
    backgroundColor: 'inherit',
    display: 'flex',
    flexDirection: 'column',
    padding: 16,
    gap: 16,
  },
  headerContainer: {
    display: 'flex',
    backgroundColor: 'inherit',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  headerTitle: {
    color: theme.colors.text.title,
  },
  progressBar: {
    backgroundColor: 'inherit',
    height: 6,
    borderRadius: 4,
    display: 'flex',
    gap: 4,
    flexDirection: 'row',
    maxWidth: '100%',
  },
  progressIndicator: {
    backgroundColor: theme.colors.success,
    height: 6,
    borderRadius: 4,
    width: '80%',
  },
  progressEmpty: {
    backgroundColor: theme.colors.text.caption,
    height: 6,
    borderRadius: 4,
    flex: 1,
  },
  stagesContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
};
